import React from "react";

import { Link } from "react-router-dom";

import Aviation from "../Assets/avation.png";
import Logistics from "../Assets/logistics.png";
import Constructions from "../Assets/constructions.png";
import Healthcare from "../Assets/healthcare.png";
import Retail from "../Assets/retail.png";

const OurDomain = () => {
  return (
    <>
      <section id="section10">
        <div className="our_domain" id="our-domain">
          <div className="heading">
            <h3>
              Our <span>Domain</span>
            </h3>
            <h5>
              Dedicated to your <span>growth and success.</span>
            </h5>
          </div>
        </div>
        <div className="container">
          <div className="row"></div>
          <div className="domains-list">
            <div className="row mb-4">
              <div className="col-xl-4 col-lg-6">
                <div className="domain">
                  <div className="img-circle">
                    <img src={Aviation} width={100} alt="" />
                  </div>

                  <div className="content">
                    <h4>Aviation</h4>
                    <p>
                      With years of experience in the Aviation industry, Fidus
                      has been providing comprehensive aviation training with
                      courses tailored to the specific needs of pilots, ground
                      staff, and other aviation professionals.
                    </p>
                  </div>
                  <Link to={"/aviation"}>
                    <button className="know-more">KNOW MORE</button>
                  </Link>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6">
                <div className="domain">
                  <div className="img-circle">
                    <img src={Logistics} width={100} alt="" />
                  </div>

                  <div className="content">
                    <h4>Logistics</h4>
                    <p>
                      In an industry where every moment counts and safety is of
                      utmost importance, staying ahead of the competition is
                      essential. Our custom eTraining solutions are meticulously
                      crafted to address the distinct challenges and needs of
                      the transportation and logistics sector
                    </p>
                  </div>
                  <Link to={"/logistics"}>
                    <button className="know-more">KNOW MORE</button>
                  </Link>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6">
                <div className="domain">
                  <div className="img-circle">
                    <img src={Constructions} width={100} alt="" />
                  </div>

                  <div className="content">
                    <h4>Constructions</h4>
                    <p>
                      In the constantly changing landscape of healthcare, it's
                      vital for professionals to remain current with the latest
                      protocols and advancements. Conventional training
                      approaches often prove cumbersome and time-intensive,
                      resulting in gaps in knowledge that can impede patient
                      care.
                    </p>
                  </div>
                  <Link to={"/construction"}>
                    <button className="know-more">KNOW MORE</button>
                  </Link>
                </div>
              </div>
              <div className="col-xl-2 d-xl-block d-none"></div>
              <div className="col-xl-4 col-lg-6">
                <div className="domain">
                  <div className="img-circle">
                    <img src={Healthcare} width={100} alt="" />
                  </div>

                  <div className="content">
                    <h4>Healthcare</h4>
                    <p>
                      In the constantly changing landscape of healthcare, it's
                      vital for professionals to remain current with the latest
                      protocols and advancements. Conventional training
                      approaches often prove cumbersome and time-intensive,
                      resulting in gaps in knowledge that can impede patient
                      care..
                    </p>
                  </div>
                  <Link to={"/healthcare"}>
                    <button className="know-more">KNOW MORE</button>
                  </Link>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6">
                <div className="domain">
                  <div className="img-circle">
                    <img src={Retail} width={100} alt="" />
                  </div>

                  <div className="content">
                    <h4>Retail</h4>
                    <p>
                      Maximize the capabilities of your retail staff with our
                      advanced online training programs, meticulously crafted to
                      address the unique challenges of the retail industry. In
                      an environment where customer expectations are constantly
                      evolving
                    </p>
                  </div>
                  <Link to={"/retail"}>
                    <button className="know-more">KNOW MORE</button>
                  </Link>
                </div>
              </div>
              <div className="col-xl-2 d-xl-block d-none"></div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OurDomain;
